import custom from './modules/custom/store.js'
import demo from './modules/demo/store.js'
import dashboard from './modules/dashboard/store.js'
import globalvariables from './modules/globalvariables/store.js'
import game from './modules/game/store.js'
import report from './modules/report/store.js'
import persistence from './modules/persistence/store.js'
import outputmessages from './modules/outputmessages/store.js'
export default { custom, demo, dashboard, globalvariables, game, report, persistence, outputmessages }